import {
	InputField,
	Select,
	TableFilterWrapper,
} from '@welbe/web-design-system';
import { OptionProps } from '@welbe/web-design-system/lib/components/molecules/Select/Select';
import { handleKeyPress } from 'utils/keyPressHandler';

type EmployeeFiltersProps = {
	height: number;
	onChangeFilters: (filter: { [key: string]: any }) => void;
	isLoadingBranchOffice: boolean;
	branchOfficeOptions: any;
	isLoadingJobProfile: boolean;
	risksProfile: OptionProps[];
	expositionAreas: OptionProps[];
	onSearch: () => void;
};

const EmployeeStatus = [
	{
		id: '',
		value: 'Selecione...',
	},
	{
		id: 'active',
		value: 'Activo',
	},
	{ id: 'inactive', value: 'Inactivo' },
];

export const EmployeeFilters = ({
	height,
	onChangeFilters,
	isLoadingBranchOffice,
	branchOfficeOptions,
	isLoadingJobProfile,
	risksProfile,
	expositionAreas,
	onSearch,
}: EmployeeFiltersProps) => {
	const formatterArrayFilter = (field: string, array: any) => {
		const filter = array.map((item: any) => item.id).join(',');
		onChangeFilters({ [field]: filter });
	};

	return (
		<TableFilterWrapper height={height}>
			<Select
				id="branchOffice"
				disabled={isLoadingBranchOffice}
				placeholder="Selecione..."
				loading={isLoadingBranchOffice}
				label="Sucursal"
				inputBackground="white"
				required
				options={branchOfficeOptions}
				onChange={(value) => onChangeFilters({ branchOfficeId: value.id })}
			/>
			<InputField
				id="name"
				placeholder="Busca por nombre"
				background="white"
				label="Nombre"
				onKeyPress={(e) => handleKeyPress(e, onSearch)}
				onChange={(value) => onChangeFilters({ name: value })}
			/>
			<InputField
				id="companyBadgeNumber"
				placeholder="Busca por número de empleado"
				background="white"
				label="Número de empleado"
				onKeyPress={(e) => handleKeyPress(e, onSearch)}
				onChange={(value) => onChangeFilters({ companyBadgeNumber: value })}
			/>
			<InputField
				id="shift"
				placeholder="Busca por turno"
				background="white"
				label="Turno"
				onKeyPress={(e) => handleKeyPress(e, onSearch)}
				onChange={(value) => onChangeFilters({ shift: value })}
			/>
			<Select
				id="status"
				placeholder="Selecione..."
				label="Status"
				inputBackground="white"
				initialSelected={EmployeeStatus.find((status) => status.id === '')}
				options={EmployeeStatus}
				onChange={(value) => onChangeFilters({ status: value.id ?? '' })}
			/>
			<Select
				id="riskProfile"
				disabled={isLoadingJobProfile}
				loading={isLoadingJobProfile}
				label="Perfil de riesgo"
				inputBackground="white"
				placeholder="Selecione..."
				options={risksProfile}
				onChange={(value) => formatterArrayFilter('riskProfileIds', value)}
				multiple
				topDistanceCheckBox="3.5px"
			/>
			<Select
				id="expositionAreas"
				disabled={isLoadingJobProfile}
				loading={isLoadingJobProfile}
				label="Áreas de exposición"
				inputBackground="white"
				placeholder="Selecione..."
				options={expositionAreas}
				onChange={(value) => formatterArrayFilter('expositionAreaIds', value)}
				multiple
				topDistanceCheckBox="3.5px"
			/>
		</TableFilterWrapper>
	);
};
